module.exports = __webpack_public_path__ + "static/media/inf_23pog24p.535f75f1.mp3";